import Component from './creative-moderation-modal';

export default Component;
